<template>
  <div class="why-sogdo-container">

    <!-- Carousel Hero Section -->
    <ServicesItsCarouselComp 
      :slides="carouselSlides"
      :mission-vision="missionVisionData"
      background-image="/resource/service-details.jpg"
      pattern-image="/shapes/shape-06.png"
    />

     <!-- How Sogdo Works Section -->
    <WhySogdoItsHowWorksComp
      :header-data="howWorksHeaderData"
      :intro-data="howWorksIntroData"
      :mission-data="howWorksMissionData"
      :leadership-data="howWorksLeadershipData"
      :approach-data="howWorksApproachData"
      :policy-data="howWorksPolicyData"
      :benefits-data="howWorksBenefitsData"
      :cta-data="howWorksCtaData"
      :contact-data="howWorksContactData"
    />

    <!-- 2. Why Sogdo? - Creative Design -->
    <WhySogdoItsCreativeComp 
      :header-data="creativeHeaderData"
      :features="creativeFeatures"
      :decorative-shapes="decorativeShapes"
    />

    <!-- Innovation Showcase Section -->
    <WhySogdoItsInnovationComp 
      :showcase-images="innovationShowcaseImages"
      :decorative-elements="innovationDecorativeElements"
      :content-data="innovationContentData"
    />
    <!-- Mission, Vision, Values Section -->
    <WhySogdoItsCoreValuesComp 
      :header-data="coreValuesHeaderData"
      :core-values-cards="coreValuesCards"
    />

    <!-- Our Values Section -->
    <WhySogdoItsOurValuesComp
      :header-data="ourValuesHeaderData"
      :values-list="ourValuesList"
      background-image="~@/assets/images/banner/banner-two.jpg"
    />

    <!-- Why Choose Sogdo Section -->
    <WhySogdoItsWhyChooseComp
      :header-data="whyChooseHeaderData"
      :choose-cards="whyChooseCards"
    />

    <!-- What We Do Section -->
    <WhySogdoItsWhatWeDoComp
      :header-data="whatWeDoHeaderData"
      :services-list="whatWeDoServices"
    />

   

  </div>
</template>

<script>
import { onMounted } from 'vue'
import WOW from 'wowjs'
import ServicesItsCarouselComp from '@/components/ServicesItsCarouselComp.vue'
import WhySogdoItsCreativeComp from '@/components/WhySogdoItsCreativeComp.vue'
import WhySogdoItsInnovationComp from '@/components/WhySogdoItsInnovationComp.vue'
import WhySogdoItsCoreValuesComp from '@/components/WhySogdoItsCoreValuesComp.vue'
import WhySogdoItsOurValuesComp from '@/components/WhySogdoItsOurValuesComp.vue'
import WhySogdoItsWhyChooseComp from '@/components/WhySogdoItsWhyChooseComp.vue'
import WhySogdoItsWhatWeDoComp from '@/components/WhySogdoItsWhatWeDoComp.vue'
import WhySogdoItsHowWorksComp from '@/components/WhySogdoItsHowWorksComp.vue'

export default {
  name: "WhySogdo",
  components: {
    ServicesItsCarouselComp,
    WhySogdoItsCreativeComp,
    WhySogdoItsInnovationComp,
    WhySogdoItsCoreValuesComp,
    WhySogdoItsOurValuesComp,
    WhySogdoItsWhyChooseComp,
    WhySogdoItsWhatWeDoComp,
    WhySogdoItsHowWorksComp
  },
  data() {
    return {
      carouselSlides: [
        {
          subtitle: "Why Choose",
          titleLines: [
            { text: "Innovation & " },
            { text: "Excellence", highlight: null }
          ],
          description: "Experience cutting-edge technology solutions, ethical business practices, and sustainable growth with Sogdo's innovative approach to digital transformation.",
          buttonText: "Discover More",
          buttonLink: "/contact"
        },
        {
          subtitle: "Our Mission",
          titleLines: [
            { text: "Empowering ", highlight: "Businesses" }
          ],
          description: "We bridge technology and business growth, delivering sustainable solutions that drive innovation, enhance productivity, and create lasting value for our clients.",
          buttonText: "Learn More",
          buttonLink: "/contact"
        },
        {
          subtitle: "Our Vision",
          titleLines: [
            { text: "Building ", highlight: "Tomorrow" }
          ],
          description: "To be a global leader in technological innovation, inspiring positive change and creating solutions that shape the future of business and society.",
          buttonText: "Join Our Journey",
          buttonLink: "/contact"
        }
      ],
      missionVisionData: {
        vision: {
          title: "Our Values",
          description: "Innovation, Integrity, Sustainability, and Community - the core principles that guide everything we do at Sogdo."
        },
        mission: {
          title: "Our Commitment",
          description: "We are committed to delivering excellence, fostering growth, and creating meaningful impact through technology and innovation."
        }
      },
      creativeHeaderData: {
        badgeText: "Why Choose",
        badgeShape: "/shapes/shape-07.png",
        titlePart1: "Why",
        titlePart2: "Sogdo",
        questionMark: "?",
        subtitle: "Experience the difference with <strong>Sogdo</strong> - where innovation meets excellence"
      },
      creativeFeatures: [
        {
          icon: "icon-01",
          title: "Cutting-Edge Technology",
          description: "Leverage the latest technologies to drive your business forward with innovative solutions.",
          cardShape: "/shapes/shape-08.png",
          stats: [
            { number: "100+", label: "Projects" },
            { number: "99%", label: "Success Rate" }
          ]
        },
        {
          icon: "icon-02",
          title: "Ethical Excellence",
          description: "Transparent, honest, and ethical business practices that build lasting trust and relationships.",
          cardShape: "/shapes/shape-10.png",
          stats: [
            { number: "5★", label: "Rating" },
            { number: "24/7", label: "Support" }
          ]
        },
        {
          icon: "icon-03",
          title: "Tailored Solutions",
          description: "Customized solutions designed specifically for your unique business needs and goals.",
          cardShape: "/shapes/shape-12.png",
          stats: [
            { number: "50+", label: "Industries" },
            { number: "100%", label: "Custom" }
          ]
        },
        {
          icon: "icon-04",
          title: "Community Impact",
          description: "Committed to sustainable growth and positive impact on communities and the environment.",
          cardShape: "/shapes/shape-02.png",
          stats: [
            { number: "1000+", label: "Lives Impacted" },
            { number: "Carbon", label: "Neutral" }
          ]
        }
      ],
      decorativeShapes: [
        { src: "/shapes/shape-01.png", alt: "Shape" },
        { src: "/shapes/shape-02.png", alt: "Shape" },
        { src: "/shapes/shape-03.png", alt: "Shape" },
        { src: "/shapes/shape-04.png", alt: "Shape" },
        { src: "/shapes/shape-05.png", alt: "Shape" },
        { src: "/shapes/shape-06.png", alt: "Shape" }
      ],
      innovationShowcaseImages: [
        { src: "/resource/portfolio-01.jpg", alt: "Innovation" },
        { src: "/resource/portfolio-02.jpg", alt: "Technology" },
        { src: "/resource/portfolio-03.jpg", alt: "Growth" }
      ],
      innovationDecorativeElements: {
        squiggle: { src: "/shapes/shape-04.png", alt: "Squiggle" },
        star: { src: "/shapes/shape-05.png", alt: "Star" }
      },
      innovationContentData: {
        title: "Discover why <span class=\"highlight-pink\">Sogdo</span> is your <span class=\"highlight-pink\">perfect</span> choice",
        descriptions: [
          "Experience the power of <strong>Sogdo's expertise</strong> in digital transformation. Our team combines cutting-edge technology with proven methodologies to deliver solutions that drive real business growth and sustainable success for companies across various industries.",
          "From innovative web development to comprehensive digital strategies, Sogdo transforms your vision into reality. Join hundreds of satisfied clients who trust us for their technological advancement and business excellence."
        ],
        buttonText: "Learn More",
        buttonLink: "/contact",
        buttonIcon: "icon-02"
      },
      coreValuesHeaderData: {
        title: "Our",
        highlight: "Core Values",
        subtitle: "The principles that guide everything we do at Sogdo"
      },
      coreValuesCards: [
        {
          type: "mission",
          icon: "icon-01",
          title: "MISSION",
          description: "Empowering businesses with innovative technology solutions for sustainable growth."
        },
        {
          type: "vision",
          icon: "icon-02",
          title: "VISION",
          description: "Leading digital transformation to enhance human potential and business success."
        },
        {
          type: "values",
          icon: "icon-03",
          title: "VALUES",
          description: "Integrity, innovation, and excellence guide our transparent partnerships and ethical practices."
        }
      ],
      ourValuesHeaderData: {
        titlePart1: "Our",
        titlePart2: "Values"
      },
      ourValuesList: [
        {
          icon: "💡",
          title: "Innovation",
          description: "Continuously pushing boundaries."
        },
        {
          icon: "🤝",
          title: "Integrity",
          description: "Transparency and ethical conduct."
        },
        {
          icon: "🌱",
          title: "Sustainability",
          description: "Building a better future."
        },
        {
          icon: "📣",
          title: "Community",
          description: "Empowering and uplifting people."
        }
      ],
      whyChooseHeaderData: {
        titlePart1: "Why Choose",
        titlePart2: "Sogdo?",
        subtitle: "Discover the unique advantages that make Sogdo the perfect partner for your digital transformation journey."
      },
      whyChooseCards: [
        {
          icon: "icon-01",
          title: "Proven Expertise",
          description: "With years of experience in digital transformation, we bring deep industry knowledge and proven methodologies to every project.",
          stat: {
            number: "500+",
            label: "Projects Completed"
          }
        },
        {
          icon: "icon-02",
          title: "Client-Centric Approach",
          description: "We prioritize your success above all else, ensuring every solution is tailored to your specific needs and business goals.",
          stat: {
            number: "98%",
            label: "Client Satisfaction"
          }
        },
        {
          icon: "icon-03",
          title: "Innovation First",
          description: "We stay ahead of the curve with cutting-edge technologies and innovative solutions that drive real business value.",
          stat: {
            number: "24/7",
            label: "Support Available"
          }
        },
        {
          icon: "icon-04",
          title: "Scalable Solutions",
          description: "Our solutions grow with your business, providing flexibility and scalability to meet your evolving needs.",
          stat: {
            number: "100%",
            label: "Scalable"
          }
        }
      ],
      whatWeDoHeaderData: {
        title: "What we do"
      },
      whatWeDoServices: [
        {
          image: require("@/assets/images/banner/banner1.png"),
          alt: "AI Technology",
          title: "AI Technology: Redefine execution boundaries to maximize productivity",
          description: "Discover how Artificial Intelligence is revolutionizing business operations with creativity and supercharged intelligence.",
          link: "#",
          linkText: "Explore AI Technology"
        },
        {
          image: require("@/assets/images/banner/banner-two.jpg"),
          alt: "Digital Solutions",
          title: "Digital Solutions: Make today's impossible tomorrow's possible",
          description: "Unlock the full potential of digital transformation and shape the future to create new capabilities, unique business models and game-changing opportunities.",
          link: "#",
          linkText: "Explore Digital Solutions"
        },
        {
          image: require("@/assets/images/resource/portfolio-01.jpg"),
          alt: "Automation",
          title: "AUTOMATION: Simplify the complex, deliver the brilliant",
          description: "Discover the streamlined, cost-efficient and intelligent answer to increasingly complex customer, IT and network demands.",
          link: "#",
          linkText: "Explore Automation"
        }
      ],

      // How Sogdo Works Section Data
      howWorksHeaderData: {
        icon: "fas fa-cogs",
        tag: "HOW SOGDO WORKS",
        title: "Sogdo — Shaping the Future with Humanity and Technology",
        description: "Discover how we're revolutionizing the way organizations work and grow"
      },

      howWorksIntroData: {
        title: "Sogdo — Shaping the Future with Humanity and Technology",
        description: "Sogdo is a forward-thinking organization driving innovation across technology, education, agriculture, AI, green solutions, and human development. Through ventures like Sogdo Synergy, SogdoTech, Sogdo Academy, and Sogdo Green, we deliver impactful solutions, services, and learning opportunities that empower people and organizations alike."
      },

      howWorksMissionData: {
        title: "Our Mission",
        description: "To improve lives by aligning technology and humanity, ensuring they work together to create real progress. We connect developers with startups, foster research, and build future-ready products that support individual growth, business success, and sustainable development."
      },

      howWorksLeadershipData: {
        title: "How We Lead",
        description: "We've eliminated traditional roles like CEO, Managers, and HR in favor of a lean, efficient structure. I serve as Controller, working directly with the Co-Founder and teams to bridge strategy and execution across projects. Roles are dynamic—from entry-level to Tech Lead—based on demand. Above Tech Lead, the Controller role oversees collaboration and alignment without unnecessary hierarchy."
      },

      howWorksApproachData: {
        title: "Our Work Approach",
        description: "Using our proprietary 360° Champa Methodologies, we optimize every task for speed, quality, and efficiency—creating an agile, politics-free workplace built on trust, transparency, and innovation."
      },

      howWorksPolicyData: {
        title: "People-First Policy — Hiring, Not Firing",
        description: "We don't let go of team members due to temporary downtime. Instead, we support them through reskilling, R&D, or community initiatives. Every person is a valued part of the Sogdo family."
      },

      howWorksBenefitsData: {
        title: "Why Join Sogdo?",
        benefits: [
          {
            icon: "fas fa-layer-group",
            title: "Flat Hierarchy",
            description: "No politics. Your impact speaks."
          },
          {
            icon: "fas fa-balance-scale",
            title: "Flexible Culture",
            description: "Balanced and sustainable work life."
          },
          {
            icon: "fas fa-graduation-cap",
            title: "Growth & Learning",
            description: "Work on cutting-edge tech with real mentorship."
          },
          {
            icon: "fas fa-shield-alt",
            title: "Job Security",
            description: "We invest in people, not just positions."
          },
          {
            icon: "fas fa-lightbulb",
            title: "Innovation Focus",
            description: "AI, green tech, education, and more."
          },
          {
            icon: "fas fa-globe",
            title: "Real-World Impact",
            description: "Contribute to meaningful projects that improve lives."
          }
        ]
      },

      howWorksCtaData: {
        title: "Let's Build the Future Together",
        description: "At Sogdo, you don't just work—you shape the future. Join us in creating a world where technology uplifts humanity, not replaces it."
      },

      howWorksContactData: {
        email: "say@sogdo.com"
      }
    }
  },
  setup() {
    onMounted(() => {
      // Initialize WOW.js
      new WOW.WOW({
        mobile: false
      }).init()
    })
  },
  methods: {
    exploreMore() {
      alert("Exploring more about Sogdo 🚀");
    },
  },
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* --- Main Container --- */
.why-sogdo-container {
  display: flex;
  flex-direction: column;
}

/* Carousel Hero Section Styles - Now handled by ServicesItsCarouselComp component */
.why-sogdo-container section.banner__two {
  padding-top: 100px !important;
  padding-bottom: 100px !important;
}

/* --- Main Section Styling --- */
.why-sogdo-section {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  background: linear-gradient(145deg, hsl(208, 63%, 7%), #071b24);
}

/* --- Background Overlay with Gradient & Shapes --- */
.background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
    background-image: url('~@/assets/images/banner/banner1.png'); /* Ensure path is correct */
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  filter: brightness(0.4);
  z-index: 1;
}

/* --- Content Container --- */
.content-container {
  z-index: 2;
  color: #fff;
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
}

/* --- Main Title --- */
.main-title {
  font-size: 64px;
  font-weight: 800;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
  margin-bottom: 30px;
  line-height: 1.2;
}

/* --- Description --- */
.description {
  font-size: 20px;
  line-height: 1.6;
  margin-bottom: 30px;
  max-width: 800px;
  opacity: 0.9;
}

/* --- Subtitle --- */
.subtitleA {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 3px;
  text-transform: uppercase;
  margin-bottom: 20px;
  opacity: 0.8;
}

/* --- Highlighted Text --- */
.highlight {
  color: #ff0e75;
  background: linear-gradient(145deg, #ff0e75, #ff6e5a);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- Button Styling --- */
.btn-primary {
  padding: 15px 40px;
  border: none;
  border-radius: 30px;
  background-color: #ff0e75;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  transition: 0.3s;
}

.btn-primary:hover {
  background-color: #074763;
  transform: translateY(-5px);
}

/* --- Why Sogdo Creative Section - Now handled by WhySogdoItsCreativeComp component --- */

/* Mission, Vision, Values Section - Now handled by WhySogdoItsCoreValuesComp component */

/* Our Values Section - Now handled by WhySogdoItsOurValuesComp component */

/* Why Choose Sogdo Section - Now handled by WhySogdoItsWhyChooseComp component */

/* What We Do Section - Now handled by WhySogdoItsWhatWeDoComp component */

/* Innovation Showcase Section - Now handled by WhySogdoItsInnovationComp component */


.why-cta {
  text-align: center;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 30px;
  padding: 60px 40px;
  border: 1px solid rgba(246, 236, 79, 0.1);
  backdrop-filter: blur(15px);
}

.cta-title {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.cta-description {
  font-size: 18px;
  color: #ccc;
  margin-bottom: 40px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary-cta, .btn-secondary-cta {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-family: 'Archivo', sans-serif;
}

.btn-primary-cta {
  background: linear-gradient(135deg, #F6EC4F, #FB0E76);
  color: #0a0e27;
}

.btn-primary-cta:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 30px rgba(246, 236, 79, 0.4);
}

.btn-secondary-cta {
  background: transparent;
  color: #F6EC4F;
  border: 2px solid #F6EC4F;
}

.btn-secondary-cta:hover {
  background: #F6EC4F;
  color: #0a0e27;
  transform: translateY(-3px);
}

.btn-icon {
  transition: transform 0.3s ease;
}

.btn-primary-cta:hover .btn-icon,
.btn-secondary-cta:hover .btn-icon {
  transform: translateX(5px);
}

/* --- Mission Section --- */
.mission-section {
  padding: 80px 0;
  background: linear-gradient(145deg, #074763, #0a3c4a);
  position: relative;
}

/* --- Vision Section --- */
.vision-section {
  padding: 80px 0;
  background: linear-gradient(145deg, #063a4c, #071b24);
  position: relative;
}

/* --- Values Section --- */
.values-section {
  padding: 80px 0;
  background: linear-gradient(145deg, #0a3c4a, #071b24);
  position: relative;
}

/* --- List Container --- */
.list-container {
  width: 100%;
  max-width: 800px;
  text-align: left;
  margin-top: 30px;
}

/* --- List --- */
.points-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.points-list li {
  font-size: 20px;
  margin-bottom: 15px;
  color: #f1f1f1;
  padding-left: 30px;
  position: relative;
  text-align: left;
  line-height: 1.5;
  display: flex;
  align-items: flex-start;
}

.points-list li::before {
  content: '•';
  color: #ff0e75;
  font-size: 20px;
  position: absolute;
  left: 0;
  top: 0;
  line-height: 1.5;
  margin-right: 10px;
}

/* --- Responsive Design --- */
@media (max-width: 768px) {
  .why-sogdo-container section.banner__two {
    padding-top: 80px !important;
    padding-bottom: 80px !important;
  }
  
  .content-container {
    padding: 30px 15px;
  }
  
  .main-title {
    font-size: 42px;
    margin-bottom: 20px;
  }
  
  .description {
    font-size: 18px;
    margin-bottom: 25px;
  }
  
  .btn-primary {
    padding: 12px 30px;
    font-size: 18px;
  }
  
  .list-container {
    margin-top: 25px;
  }
  
  .points-list li {
    font-size: 18px;
    margin-bottom: 12px;
    padding-left: 25px;
  }
  
  .points-list li::before {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .why-sogdo-container section.banner__two {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  
  .main-title {
    font-size: 32px;
  }
  
  .description {
    font-size: 16px;
  }
  
  .subtitleA {
    font-size: 14px;
    letter-spacing: 2px;
  }
  
  .points-list li {
    font-size: 16px;
    padding-left: 20px;
  }
  
  .points-list li::before {
    font-size: 16px;
  }
}

/* Carousel Responsive Styles - Now handled by ServicesItsCarouselComp component */

/* Creative Section Responsive Styles - Now handled by WhySogdoItsCreativeComp component */
@media (max-width: 768px) {
  /* Innovation showcase responsive styles now handled by WhySogdoItsInnovationComp component */
  
  /* Mission, Vision, Values responsive styles now handled by WhySogdoItsCoreValuesComp component */

  .values-container {
    flex-direction: column;
  }
  
  .values-content {
    flex: 1;
    padding: 60px 40px;
  }
  
  .values-title {
    font-size: 36px;
  }
  
  .values-list {
    gap: 20px;
    margin-top: 30px;
  }
  
  .value-item {
    padding: 15px;
    gap: 15px;
  }
  
  .value-icon {
    font-size: 24px;
    width: 50px;
    height: 50px;
  }
  
  .value-title {
    font-size: 18px;
  }
  
  .value-description {
    font-size: 14px;
  }
  

  .choose-title {
    font-size: 36px;
    flex-direction: column;
    gap: 10px;
  }
  
  .choose-subtitle {
    font-size: 16px;
  }
  
  .choose-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  
  .choose-card {
    padding: 30px 20px;
  }
  
  .choose-card .card-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .choose-card .card-title {
    font-size: 20px;
  }
  
  .choose-card .card-description {
    font-size: 14px;
  }

  .section-title {
    font-size: 36px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .service-image {
    height: 200px;
  }
  
  .service-title {
    font-size: 20px;
  }
  
  .service-description {
    font-size: 14px;
  }

  .why-cta {
    padding: 40px 20px;
  }
  
  .cta-title {
    font-size: 28px;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .btn-primary-cta, .btn-secondary-cta {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  /* Creative section responsive styles now handled by WhySogdoItsCreativeComp component */
  
  /* Mission, Vision, Values responsive styles now handled by WhySogdoItsCoreValuesComp component */

  .values-content {
    padding: 40px 20px;
  }
  
  .values-title {
    font-size: 28px;
  }
  
  .values-list {
    gap: 15px;
    margin-top: 25px;
  }
  
  .value-item {
    padding: 12px;
    gap: 12px;
  }
  
  .value-icon {
    font-size: 20px;
    width: 40px;
    height: 40px;
  }
  
  .value-title {
    font-size: 16px;
  }
  
  .value-description {
    font-size: 13px;
  }
  
  .values-cta-btn {
    padding: 12px 24px;
    font-size: 14px;
  }
  

  .choose-title {
    font-size: 28px;
  }
  
  .choose-subtitle {
    font-size: 14px;
  }
  
  .choose-card {
    padding: 25px 15px;
  }
  
  .choose-card .card-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  
  .choose-card .card-title {
    font-size: 18px;
  }
  
  .choose-card .card-description {
    font-size: 13px;
  }
  
  .choose-card .stat-number {
    font-size: 24px;
  }

  .section-title {
    font-size: 28px;
  }
  
  .service-image {
    height: 180px;
  }
  
  .service-title {
    font-size: 18px;
  }
  
  .service-description {
    font-size: 13px;
  }
  
  .service-link {
    font-size: 14px;
  }

  
  
  /* Innovation showcase responsive styles now handled by WhySogdoItsInnovationComp component */


  .why-cta {
    padding: 30px 15px;
  }
  
  .cta-title {
    font-size: 24px;
  }
  
  .cta-description {
    font-size: 16px;
  }
}
</style>

